import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { isNullOrUndefined } from "util";

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    private userName: string;
    private agentHigherRole: string;

    constructor(
        private httpClient: HttpClient
    ) { }

    getAgentHigherRole(currentUserName?: string): Observable<string> {

        const shouldGetSavedRole = this.userName && (this.userName === currentUserName || isNullOrUndefined(currentUserName)) && this.agentHigherRole;

        if (shouldGetSavedRole) {
            return of(this.agentHigherRole);
        } else {
            this.userName = currentUserName;
            return this.httpClient.get<string>(`${environment.server.api.portalpas}/user/role`).pipe(
                tap(role => {
                    this.agentHigherRole = role;
                })
            );
        }
    }
}